<template>
  <section class="app-wrapper" v-if="feedsIsLoaded">
    <template v-if="getAllowed">
      <app-header
        @onToggleTranslation="toggleTranslation"
        @onToggleSidebar="handleSidebar"
        :translation-play="translationPlay.header"
        :show-sidebar="openSidebar"
      />
      <app-sidebar
        :translation-play="translationPlay.sidebar"
        :open-sidebar="openSidebar"
        @onToggleSidebar="handleSidebar"
      />
      <router-view />
    </template>
    <template v-else>
      <div class="allowed">
        Извините, у вас недостаточно прав. Обратитесь к администратору.
      </div>
    </template>
  </section>
</template>

<script>
// components
import AppHeader from "../components/appHeader/AppHeader.vue";
import AppSidebar from "../components/appSidebar/AppSidebar.vue";

//store
import {GET_FEEDS} from "../../store/actions/feeds";
import { mapGetters } from 'vuex';

const MIN_SCREEN_WIDTH = 1040;

export default {
  name: "Main",
  data() {
    return {
      screenWidth: 0,
      feedsIsLoaded: false,
      openSidebar: false,
      translationPlay: {
        sidebar: false,
        header: false,
      },
      allowedLoad: false,
    };
  },
  computed: {
    ...mapGetters(['feedsList']),
    getAllowed() {
      if (this.$route.params.id) {
        let allowedLoad = false;
        this.feedsList.forEach((item) => {
          if (parseInt(item.id, 10) === parseInt(this.$route.params.id, 10)) {
            allowedLoad = true;
          }
        });

        return allowedLoad;
      }

      return true;
    },
  },
  methods: {
    handleSidebar() {
      this.openSidebar = !this.openSidebar;
    },
    toggleTranslation() {
      if (this.screenWidth <= MIN_SCREEN_WIDTH) {
        this.translationPlay.header = !this.translationPlay.header;
      } else {
        this.translationPlay.sidebar = !this.translationPlay.sidebar;
      }
    },
  },
  mounted() {
    this.screenWidth = window.innerWidth;
    window.onresize = () => {
      if (window.innerWidth !== window.innerWidth && this.screenWidth <= MIN_SCREEN_WIDTH) {
        this.openSidebar = false;
        this.screenWidth = window.innerWidth;
      }
    };

    this.$store.dispatch(GET_FEEDS).then(() => {
      this.feedsIsLoaded = true;
    });
  },
  components: {
    AppHeader,
    AppSidebar
  },
};
</script>

<style>
@import "./css/style.css";
</style>
